"use client";

import { useEffect } from "react";

import { useAuth } from "./useAuth";
import { useSearchParams } from "next/navigation";
import { appendQueryparams } from "apps/website/utils/misc/merge-query";

export function useRedirectIfLoggedIn(redirectTo = "/") {
  const auth = useAuth();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (auth.loggedIn) {
      // Note: we use window href instead of Next router because
      // of cross-application transitions
      // TODO sanitize URL to prevent redirect attacks
      //   see https://cheatsheetseries.owasp.org/cheatsheets/Unvalidated_Redirects_and_Forwards_Cheat_Sheet.html
      console.log("useRedirectIfLoggedIn - redirectTo:", redirectTo);
      console.log("useRedirectIfLoggedIn - searchParams:", searchParams);
      //filter out postLogin from searchParams
      const filteredParams = new URLSearchParams();
      searchParams.forEach((value, key) => {
        if (key !== "postLogin") {
          filteredParams.set(key, value);
        }
      });

      console.log("useRedirectIfLoggedIn - filteredParams:", filteredParams.toString());
      const fullPath = appendQueryparams(redirectTo, filteredParams);
      console.log("useRedirectIfLoggedIn - fullPath:", fullPath);
      window.location.href = fullPath;
    }
  }, [ auth.loggedIn, redirectTo ]);
}
